module.exports = __webpack_public_path__ + "img/mood_angry.da5cd9c7.png";